export const MARKETING_LP_URL = 'https://zing.iebtinnovation.com/'
